import { decode } from "base-64"
import Cookies from "js-cookie"

function getHeaders () {
    return {
      'Content-Type': 'application/json;charset=UTF-8',
      "accept": "application/json",
      'Authorization': decode(Cookies.get('accessToken')) ? `${decode(Cookies.get("accessToken"))}` : null,
      'Access-Control-Allow-Origin': '*',
      "Content-Type": "application/json",
      // 'X-Frame-Options': 'SAMEORIGIN', 
      // 'X-XSS-Protection': '1; mode=block' 

    }
  }
  export default getHeaders